<template>
    <div>
        <div class="login_bg" v-loading="loading" element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.2)">
            <div id="particles-js" style="height:100%">

                <div class="card-body"
                     style="height:100%;width: 100%;display: flex;align-items: center;justify-content:center">
                    <div style="align-items: center;">
                        <div class="mb-4">
                            <i class="feather icon-unlock auth-icon"></i>
                        </div>
                        <h3 class="text-white">{{projectName}}</h3>

                        <div style="width: 100%;text-align: center">
                            <el-input slot="reference" class="form-control" type="text" placeholder="请输入用户名"
                                      prefix-icon="el-icon-user" @blur="getDepartmentList" @change="clearDepart()"
                                      v-model="loginName"/>
                        </div>
                        <div style="width: 100%;text-align: center">
                            <el-input slot="reference" class="form-control" type="password" placeholder="请输入密码"
                                      @keyup.enter.native="loginAction" prefix-icon="el-icon-lock"
                                      v-model="password"/>
                        </div>
                        <div style="width: 326px;text-align: center;margin-top: 8px;margin-left: 11px">

                            <el-select v-model="departmentName" filterable placeholder="请选择登录部门" style="width: 326px;">
                                <div slot="prefix" >
                                </div>
                                <el-option v-for="item in departmentList" :label="item.departmentName"
                                           style="padding-left: 10px"
                                           :value="item.departmentName" :key="item.departmentId"></el-option>
                            </el-select>
                        </div>


                        <div style="float:right;margin-top: 10px;color: white">
                            <el-checkbox label=" 记住密码" style="color: white" name="type" v-model="checked"></el-checkbox>
                        </div>

                        <div style="margin-top:20px;width: 100%;display: flex;justify-content:center">
                            <button class="loginBtn" @click="loginAction">
                                {{loginTxt}}
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import app from "@/views/login/app"
    import particles from "@/views/login/particles"
    import '@/assets/css/viewuiplus.css'

    export default {
        name: "login",
        data() {
            return {
                projectName: window.host.projectName,
                password: localStorage.getItem("password") || "", //密码
                loginName: localStorage.getItem("loginName") || "", //工号
                departmentName: localStorage.getItem("departmentNameLogin") || "", //工号,
                checked: true,
                token: localStorage.getItem("token") || "",

                loading: false,
                timer: null,
                departmentList: [],
                loginTxt: "登录"
            };
        },
        async mounted() {

            if (localStorage.getItem("saveinfo") === 'true') {
                this.checked = true;
            } else {
                this.checked = false;
            }
            await this.getDepartmentList();
            app.init();
        },
        methods: {

            async getDepartmentList() {
                if (this.loginName != undefined && this.loginName != null && this.loginName != '') {
                    console.info(this.loginName)
                    this.loading = true;
                    let param = {
                        url: "/department/listTopSel",
                        param: {
                            loginName: this.loginName,
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param);
                    if (data.data.departmentList.length > 0) {
                        this.departmentList = data.data.departmentList;
                        this.departmentName = this.departmentList[0].departmentName;
                    }
                    this.loading = false;
                }
            },
            clearDepart() {
                this.departmentList = [];
                this.departmentName = "";
            },
            async loginAction() {
                this.loading = true;
                this.loginTxt = '登录中'
                /*if (this.departmentName == null || this.departmentName == ''){
                    this.$message({message: '请选择登录部门', type: 'error'});
                    this.loginTxt = '登录'
                    this.loading = false
                    return false;
                }*/
                if (this.loginName == '' || this.password == '') {
                    this.$message({message: '账号密码不能为空', type: 'error'});
                    this.loginTxt = '登录'
                    this.loading = false
                    return false;
                }

                if (!this.token) {
                    this.token = this.$pub.getToken(32);
                }
                let par_data = {
                    "loginName": this.loginName,
                    "loginPwd": this.password,
                    "departmentNameLogin": this.departmentName
                };
                let key_data = this.$pub.encrypt(encodeURI(JSON.stringify(par_data)), this.token);

                let param = {
                    url: "/login/checkUser",
                    param: {
                        token: this.token,
                        data: key_data
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                this.loading = false;
                this.loginTxt = '登录'
                if (data.infoCode === '0') {
                    if (this.checked == true) {
                        await this.setSession()
                    } else {
                        await this.setToken();
                    }
                    await this.$router.push({path: '/main'})
                }
            },
            setSession() {
                localStorage.setItem('token', this.token);
                localStorage.setItem('loginName', this.loginName);
                localStorage.setItem('password', this.password);
                localStorage.setItem('departmentNameLogin', this.departmentName);
                localStorage.setItem('saveinfo', this.checked);
            },
            setToken() {
                localStorage.setItem('loginName', '');
                localStorage.setItem('password', '');
                localStorage.setItem('departmentNameLogin', '');
                localStorage.setItem('token', this.token);
                localStorage.setItem('saveinfo', this.checked);
            },
        }
    };
</script>

<style scoped>
    /deep/ .el-input__prefix {
        left: 15px;
        font-size: 18px;
        color: blue;
        -webkit-transition: all .3s;
        transition: all .3s;
        top: 2px;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: white;
    }

    /deep/ .el-checkbox__input .is-checked .el-checkbox__label {
        color: white;
    }

    .el-input__inner {
        padding-left: 10px;
    }

    /*背景*/
    .login_bg {
        height: 100vh;
        box-sizing: border-box;
        background-image: url('../../assets/login/bg_07.jpg');
        background-size: 100% 100%;
        overflow: hidden;
    }

    .card-body {
        position: absolute;
        width: 100%;
        z-index: 5;
        text-align: center;

    }

    .text-white {
        font-family: "Open Sans", sans-serif;
        font-size: 30px;
        font-weight: 400;
        color: #04a9f5 !important;
    }

    .form-control {
        /*background: #1dd5d2;*/
        width: 350px;
        /*height: calc(2.25rem + 10px);*/
        line-height: 2;
        padding: .375rem .75rem;
    }

    /*el-input控件*/
    /deep/ .el-input__inner {
        color: #04a9f5;
        border-color: #04a9f5;
        background-color: transparent;
        background: transparent;
        height: calc(2.25rem + 10px);
        font-weight: 500;
        font-size: 18px;
        line-height: 2;
        border-radius: .25rem;
    }

    /deep/ .el-input__inner:focus {
        background: rgba(0, 255, 255, 0.1);
        box-shadow: 3px 3px 5px #04a9f5;
    }


    /*btn按钮*/
    button {
        text-align: center;
        position: relative;
        width: 100px;
        height: 40px;
        background: linear-gradient(to right bottom, #3091f2 50%, #5cadff 0);
        cursor: pointer;
        color: #fff;
        border: none;
        margin-right: 20px;
        margin-bottom: 20px;
        overflow: hidden;
        transition: all 1s linear;
    }

    button:hover {
        transform: scale(1.1);
        animation: toBig 1s ease-in-out 1;
        -webkit-animation: toBig 1s ease-in-out 1;
        box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    }

    @keyframes toBig { /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
        0% {
            transform: scale(1); /*开始为原始大小*/
        }
        100% {
            transform: scale(1.1);
        }
    }

    .loginBtn span {
        position: absolute;
        display: block;
    }

    .loginBtn span:nth-child(1) {
        height: 2px;
        width: 120px;
        top: 0;
        left: -200px;
        background: linear-gradient(90deg, transparent, #cde6c7);
        border-top-right-radius: 1px;
        border-bottom-right-radius: 1px;
        -webkit-animation: topMove 2s linear infinite;
        animation: topMove 2s linear infinite;
        -webkit-animation-delay: 0s;
        animation-delay: 0s;
    }

    @keyframes topMove {
        from {
            left: -200px;
        }
        to {
            left: 100%;
        }
    }

    @-webkit-keyframes topMove { /*Safari 和 Chrome*/
        from {
            left: -200px;
        }
        to {
            left: 100%;
        }
    }

    .loginBtn span:nth-child(2) {
        height: 2px;
        width: 120px;
        bottom: 0;
        right: -200px;
        background: linear-gradient(270deg, transparent, #cde6c7);
        border-top-right-radius: 1px;
        border-bottom-right-radius: 1px;
        -webkit-animation: bottomMove 2s linear infinite;
        animation: bottomMove 2s linear infinite;
        -webkit-animation-delay: 0s;
        animation-delay: 0s;
    }

    @keyframes bottomMove {
        from {
            right: -200px;
        }
        to {
            right: 100%;
        }
    }

    @-webkit-keyframes bottomMove { /*Safari 和 Chrome*/
        from {
            right: -200px;
        }
        to {
            right: 100%;
        }
    }

    .loginBtn span:nth-child(3) {
        width: 2px;
        height: 50px;
        left: 0;
        bottom: -100px;
        background: linear-gradient(180deg, transparent, #cde6c7);
        border-top-right-radius: 1px;
        border-bottom-right-radius: 1px;
        -webkit-animation: leftMove 2s linear infinite;
        animation: leftMove 2s linear infinite;
        -webkit-animation-delay: -1s;
        animation-delay: -1s;
    }

    @keyframes leftMove {
        from {
            bottom: -100px;
        }
        to {
            bottom: 100%;
        }
    }

    @-webkit-keyframes leftMove { /*Safari 和 Chrome*/
        from {
            bottom: -100px;
        }
        to {
            bottom: 100%;
        }
    }

    .loginBtn span:nth-child(4) {
        width: 2px;
        height: 50px;
        right: 0;
        top: -100px;
        background: linear-gradient(0deg, transparent, #cde6c7);
        border-top-right-radius: 1px;
        border-bottom-right-radius: 1px;
        -webkit-animation: rightMove 2s linear infinite;
        animation: rightMove 2s linear infinite;
        -webkit-animation-delay: -1s;
        animation-delay: -1s;
    }

    @keyframes rightMove {
        from {
            top: -100px;
        }
        to {
            top: 100%;
        }
    }

    @-webkit-keyframes rightMove { /*Safari 和 Chrome*/
        from {
            top: -100px;
        }
        to {
            top: 100%;
        }
    }

</style>
